import { useQuery } from '@hooks/reactQuery';

import { getOrganisationProfile } from '@api/organisations';

import { extractQueryParams } from '@utils/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROFILE } from '@constants/queryKeys';

export const useQueryOrganisationProfileById = (id?: string) => {
	const {
		data,
		isLoading: isLoadingProfile,
	} = useQuery({
		queryKey: [ORGANISATION_PROFILE, id],
		queryFn: extractQueryParams(getOrganisationProfile),
		enabled: [!!id],
		...refetchOptions,
	});

	return {
		profile: data || {},
		isLoadingProfile,
	};
};
